import PropTypes from "prop-types";
import SearchBookingForm from "app/pages/CorporateSite/SearchBooking/SearchBookingForm";
import { useCallback } from "react";
import { sendTagOnBookingSearch } from "app/utils/analytics";
import {
	authSuccess as authSuccessAction,
	authSuccessForShop,
	loginWithBookingReference as loginWithBookingReferenceAction,
} from "app/pages/Auth/AuthActions";
import { parseQueries } from "app/utils/routerUtils";
import { HTTP_STATUS_CODES } from "app/constants";
import { useInvalidateMyBookingsNotification } from "app/features/myBookings";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

const searchBookingErrorGenerate = status =>
	({
		[HTTP_STATUS_CODES.NOT_FOUND]: "error.booking.not.found.error",
		[HTTP_STATUS_CODES.TOO_MANY_REQUEST]: "error.booking.too.many.request.error",
	})[status] || "error.generic";

const SearchBookingFormContainer = ({ onClickRecover = () => {}, disabledRecoverData = false }) => {
	const location = useLocation();
	const navigate = useNavigate();

	const shop = useSelector(state => state.shop);

	const dispatch = useDispatch();
	const authSuccess = useCallback((...args) => dispatch(authSuccessAction(...args)), [dispatch]);
	const invalidateMyBookingsNotification = useInvalidateMyBookingsNotification();
	const loginWithBookingReference = useCallback(
		(...args) => dispatch(loginWithBookingReferenceAction(...args)),
		[dispatch]
	);

	const handleSubmit = (values, { setErrors, setStatus, setSubmitting }) => {
		sendTagOnBookingSearch({
			password: values.bookingReference,
			email: values.email,
		});

		loginWithBookingReference({
			password: values.bookingReference,
			email: values.email,
		}).then(res => {
			setSubmitting(false);

			if (res.status === HTTP_STATUS_CODES.OK) {
				setStatus({ success: true });
				authSuccess(res);

				const query = parseQueries(location.search);
				let pathname = "/account/mybookings";

				if (query.onauthsuccess) {
					pathname = query.onauthsuccess;
				}

				const currentShop = shop;
				const shopFormResponse = res?.data?.partner?.shop;
				const email = res?.data?.email;

				if (shopFormResponse && currentShop !== shopFormResponse) {
					const partnerCode = res?.data?.partner?.code;
					const token = res?.data?.token;
					const uuid = res?.data?.uuid;

					authSuccessForShop({ shop: shopFormResponse, partnerCode, token, uuid, email });

					invalidateMyBookingsNotification();

					window.location = `${window.origin}/${shopFormResponse}${pathname}`;
				} else {
					authSuccess(res);
					invalidateMyBookingsNotification();

					if (query.onauthsuccess) {
						// we don't want the user to go to the auth page on back
						navigate(pathname, { replace: true });
					} else {
						navigate(pathname);
					}
				}
			} else {
				setErrors({
					_error: {
						id: searchBookingErrorGenerate(res.status),
					},
				});
				setStatus({ success: false });
			}
		});
	};

	return (
		<SearchBookingForm
			handleSubmit={handleSubmit}
			onClickRecover={onClickRecover}
			disabledRecoverData={disabledRecoverData}
		/>
	);
};

SearchBookingFormContainer.propTypes = {
	onClickRecover: PropTypes.func,
	disabledRecoverData: PropTypes.bool,
};

export default SearchBookingFormContainer;
